import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TablePagination,
  TableRow,
  TableHead,
  Paper, 
  Button,
  TextField, 
  MenuItem
} from "@mui/material";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/Card';
import { Input } from '../../components/ui/Input';

const Shifts = ({ refresh }) => {
  const baseURL = process.env.REACT_APP_API_URL;
const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [editingShift, setEditingShift] = useState(null);
  const [formData, setFormData] = useState({
    type:'',
    shift_name: '', 
      start_time: '',
      end_time: '',
  });

  const [shifts, setShifts] = useState([]);
  const [type, setType] = useState("");
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const fetchShifts = async () => {
    try {
      const res = await axios.get(`${baseURL}shifts`);
      setShifts(res.data);
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  useEffect(() => {
    fetchShifts();
  }, [refresh]);

  const deleteShift = async (id) => {
    try {
      await axios.delete(`${baseURL}shifts/${id}`);
      fetchShifts();
    } catch (error) {
      console.error("Delete error:", error);
    }
  };

  // Pagination logic
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const visibleRows =
    rowsPerPage > 0
      ? shifts.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
      : shifts;
  const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const submitData = {
      name: formData.shift_name,
      type: formData.type,
      start_time: formData.start_time,
      end_time: formData.end_time
    };

    await axios.post(`${baseURL}shifts`, submitData);

    fetchShifts(); // better than manual push
    resetForm();
    setIsAddModalOpen(false);

  } catch (error) {
    console.error(error);
  }
};
   const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  const resetForm = () => {
    setFormData({
      type: '', 
      shift_name: '', 
      start_time: '',
      end_time: '',
     
    });
  };
  return (
    <div><Box>      
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">Shift Management</h2>
          <p className="text-muted-foreground">Manage shift</p>
        </div>
        <Button onClick={() => setIsAddModalOpen(true)}>
          + Add Shift
        </Button>
      </div>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>Time</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Action</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {visibleRows.map((s) => (
              <TableRow key={s.id}>
                <TableCell>{s.name}</TableCell>
                <TableCell>
                  {s.start_time} - {s.end_time}
                </TableCell>
                <TableCell>{s.type}</TableCell>
                <TableCell>
                  <Button
                    color="error"
                    variant="contained"
                    onClick={() => deleteShift(s.id)}
                  >
                    Delete
                  </Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>

          <TableFooter>
            <TableRow>
              <TablePagination
                rowsPerPageOptions={[5, 10, 25]}
                count={shifts.length}
                rowsPerPage={rowsPerPage}
                page={page}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </TableContainer>
    </Box>
    <Card>
    {isAddModalOpen && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
              <Card className="w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto">
                <CardHeader>
                  <CardTitle>{editingShift ? 'Edit Shift' : 'Add New Shift'}</CardTitle>
                  <CardDescription>
                    {editingShift ? 'Update Shift details' : 'Enter Shift information to add to the system'}
                  </CardDescription>
                </CardHeader>
                <CardContent>
                  <form onSubmit={handleSubmit} className="space-y-4">


                    <div className="grid grid-cols-2 gap-4">
                      <div>
                        <label className="block text-sm font-medium mb-1">Shift Type *</label>
                        <TextField
                        select
                        name="type"
                        label="Select Type"
                        value={formData.type}
                        onChange={handleInputChange}
                        fullWidth
                      >
                        <MenuItem value="">-- Select Shift --</MenuItem>
                        <MenuItem value="night">Night Shift</MenuItem>
                        <MenuItem value="rotational">Rotational Shift</MenuItem>
                        <MenuItem value="emergency">Emergency</MenuItem>
                      </TextField>
                      </div>
                      <div>
                        <label className="block text-sm font-medium mb-1">Shift Name *</label>
                        <Input
                          name="shift_name"
                          value={formData.shift_name}
                          onChange={handleInputChange}
                          placeholder="Enter shift name"
                          required
                        />
                      </div>
                      
                    </div>
    
                    <div className="grid grid-cols-2 gap-4">     
                      <div>
                        <label className="block text-sm font-medium mb-1">Start Time</label>
                        <Input
                          name="start_time"
                          type="time"
                          value={formData.start_time}
                          onChange={handleInputChange}
                        />
                      </div>               
                      <div>
                        <label className="block text-sm font-medium mb-1">End Time</label>
                        <Input
                          name="end_time"
                          type="time"
                          value={formData.end_time}
                          onChange={handleInputChange}
                        />
                      </div>
                    </div>
                    
                    <div className="flex gap-2 pt-4">
                      <Button type="submit" className="flex-1">
                        {editingShift ? 'Update' : 'Add'} Shift
                      </Button>
                      <Button 
                        type="button" 
                        variant="outline" 
                        onClick={() => {
                          setIsAddModalOpen(false);
                          setEditingShift(null);
                          resetForm();
                        }}
                      >
                        Cancel
                      </Button>
                    </div>
                  </form>
                </CardContent>
              </Card>
            </div>
          )}
          </Card>
          </div>
  );
};

export default Shifts;